
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import TitleAndPromotions from '@/apps/shared/components/TitlesAndPromotions.vue';
    import ExtendedContactInfo from "@/apps/shared/components/ExtendedContactInfo.vue";
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';

    export default defineComponent({
        name: 'travelAssistance-tab-One',
        components: {
            XBreadcrumb,
            TitleAndPromotions,
            ExtendedContactInfo,
        },
        data() {
            return {
                titleAndPromotionDetails: {
                    title: "Asistencia al Viajero",
                    subTitle: "Para comenzar, vamos a pedirte algunos datos personales",
                    product: "Viajes",
                    icon: {
                        src: '/Logos/viajes.svg',
                        alt: 'Asistencia al Viajero',
                        title: 'Asistencia al Viajero'
                    },
                    iconPromotion: {
                        src: '/Logos/viajes-promo.png',
                        alt: 'viajes-promo',
                        title: 'viajes-promo'
                    }
                } as TitleAndPromotionsDetails,
                breadcrumItems: [
                    { text: 'Inicio', path: '/asistencia-viajero' },
                    { text: 'Datos Personales', path: '/asistencia-viajero/' },
                ],
                leadId: null,
                referente: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                const actualStep = 'tab-one';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                }
                catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultTravelAssistanceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            async comenzar() {
                const extendedContactInfoData = this.$refs.extendedContactInfoRef.getFormData();
                NF.Validation.Form.validate('#formData');
                const { firstName, lastName, email, telephone, areaCode, validTelephone, validEmail } = extendedContactInfoData;

                const validName = firstName && firstName.trim() !== "";
                const validLastName = lastName && lastName.trim() !== "";
                const validateEmail = validEmail;

                if (validName && validLastName && validTelephone && validateEmail) {
                    NF.UI.Page.block();

                    // Guardar datos en sessionStorage para las siguientes pantallas
                    sessionStorage.setItem("DataTabHome", JSON.stringify({
                        firstName: firstName,
                        lastName: lastName,
                        areaCode: areaCode,
                        telephone: telephone,
                        email: email
                    }));

                    // GTM dataLayer push
                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': email,
                        'product': 'asistencia-viajero',
                        'event': 'cotizador-viajero-datos-personales',
                        'referente': this.referente
                    });

                    // Crear o editar Lead en CRM
                    // TODO: Definir productId correcto para Asistencia al Viajero
                    CRMCotizadorWebService.CreateOrEditLead(this.leadId, email, location.href, areaCode, telephone, null, false, "1", null, lastName, firstName)
                        .then((response) => {
                            sessionStorage.setItem("LeadId", JSON.stringify(response));
                            this.$router.push({
                                name: 'travelAssistance-tab-two',
                            });
                            NF.UI.Page.unblock();
                        })
                        .catch(error => {
                            NF.UI.Page.unblock();
                            let statusCode = null;
                            if (error.response && error.response.status) {
                                statusCode = error.response.status;
                            }
                            console.error("Error en la ejecución:", error);
                            window.globalThis.dataLayer.push({
                                'pas': null,
                                'email': email,
                                'product': 'asistencia-viajero',
                                'event': 'errorUsuario',
                                'paso': 'cotizador-viajero-datos-personales',
                                'referente': this.referente
                            });
                            this.Bus.$emit('show-service-fail', statusCode, [() => this.comenzar()]);
                        });
                } else {
                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': email,
                        'product': 'asistencia-viajero',
                        'event': 'errorUsuario',
                        'paso': 'cotizador-viajero-datos-personales',
                        'referente': this.referente
                    });
                }
            },

            getInitData() {
                this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                var validBack = sessionStorage.getItem("pressBack");
                if (validBack) {
                    sessionStorage.removeItem("pressBack");
                    var dataTomador = sessionStorage.getItem("DataTabHome");
                    if (dataTomador != null) {
                        var dataTomadorJson = JSON.parse(dataTomador);
                        this.$refs.extendedContactInfoRef.setFormData(dataTomadorJson);
                    }
                }
                else {
                    window.globalThis.dataLayer.push({
                        'pas': null,
                        'email': null,
                        'product': 'asistencia-viajero',
                        'event': 'cotizador-viajero-view',
                        'referente': this.referente
                    });
                    sessionStorage.clear();
                    sessionStorage.setItem("Referente", this.referente);
                    sessionStorage.setItem("ExitOrContinueModal", "true");
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;

                await this.pageCustomization();
                await this.updateByProductGoogleAnalytics();

                this.getInitData();
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
